const PropertyVisibilities = [
  { id: 'ramp_ad_units', name: 'RAMP Ad Units' },
  { id: 'bordeaux_ad_units', name: 'Bordeaux Ad Units' }
];

export default PropertyVisibilities;



// WEBPACK FOOTER //
// ./src/views/StaticData/PropertyVisibilities.tsx